import type { FileKind, ProjectFile } from "../../worker/shared/contracts";

const extensions: Partial<Record<FileKind, string>> = {
  note: "note", aml: "aml", system: "sys",
};
export function fileExtension(file: Pick<ProjectFile, "name" | "kind" | "extension">): string {
  if (file.kind === "folder") return "";
  return extensions[file.kind] || file.extension || (file.name.includes(".") ? file.name.split(".").at(-1)! : file.kind === "data" ? "table" : file.kind === "drawing" ? "drawing" : "");
}
export function fileName(file: Pick<ProjectFile, "name" | "kind" | "extension">): string {
  const extension = fileExtension(file);
  return extension && !file.name.toLowerCase().endsWith(`.${extension.toLowerCase()}`)
    ? `${file.name}.${extension}` : file.name;
}
